import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.map";
import _omit from "lodash/omit";
import _forEach from "lodash/forEach";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import defined from 'defined';
import { SELECT_DEFAULT_PROPS } from '../prop-types';
import DropdownTrigger from '../dropdown-trigger'; // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

var Option = function Option(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      value = _ref.value;
  return /*#__PURE__*/React.createElement("option", {
    value: defined(value, label),
    disabled: disabled
  }, label);
};

Option.displayName = 'Option';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require = require('../prop-types'),
      OPTION_PROPS = _require.OPTION_PROPS;

  Option.propTypes = OPTION_PROPS;
} // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration


var OptGroup = function OptGroup(_ref2) {
  var title = _ref2.title,
      options = _ref2.options;
  return /*#__PURE__*/React.createElement("optgroup", {
    label: title,
    key: title
  }, options.map(function (o) {
    return /*#__PURE__*/React.createElement(Option, _extends({}, o, {
      key: defined(o.value, o.label)
    }));
  }));
};

OptGroup.displayName = 'OptGroup';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require2 = require('../prop-types'),
      OPTION_GROUP_PROPS = _require2.OPTION_GROUP_PROPS;

  OptGroup.propTypes = OPTION_GROUP_PROPS;
}
/**
 * Renders a native select component.
 */


var NativeSelect = /*#__PURE__*/function (_Component) {
  _inherits(NativeSelect, _Component);

  var _super = _createSuper(NativeSelect);

  function NativeSelect() {
    var _this;

    _classCallCheck(this, NativeSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOptionChange", function (e) {
      // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      if (!_this.props.multiple) {
        // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
        _this.props.onChange(e);

        return; // short circuit to ensure onChange is only called once for native Select arrays
      }
      /*
        onChange should send back an array for multiple values
      */


      var value = [];

      if (e.target.options) {
        var options = e.target.options;

        _forEach(options, function (option) {
          if (option.selected) {
            value.push(option.value);
          }
        });
      } // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration


      _this.props.onChange({
        target: {
          value: value
        }
      });
    });

    return _this;
  }

  _createClass(NativeSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          innerRef = _this$props.innerRef,
          otherProps = _objectWithoutProperties(_this$props, ["options", "innerRef"]);

      return /*#__PURE__*/React.createElement(DropdownTrigger, _extends({}, _omit(otherProps, ['onChange']), {
        onChange: this.handleOptionChange,
        mode: "select",
        ref: innerRef
      }), options.map(function (option) {
        return option.options ? /*#__PURE__*/React.createElement(OptGroup, _extends({}, option, {
          key: option.title
        })) : /*#__PURE__*/React.createElement(Option, _extends({}, option, {
          key: defined(option.value, option.label)
        }));
      }));
    }
  }]);

  return NativeSelect;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


NativeSelect.displayName = 'NativeSelect';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _require3 = require('../prop-types'),
      SELECT_PROP_TYPES = _require3.SELECT_PROP_TYPES; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  NativeSelect.propTypes = SELECT_PROP_TYPES;
} // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


NativeSelect.defaultProps = SELECT_DEFAULT_PROPS;
export default NativeSelect;